import React from "react";

// Define expected status values
export type SDKStatus = "Installed" | "Pending" | "Uninstalled" | string; // Allow other strings for flexibility

interface StatusDotIconProps extends React.SVGProps<SVGSVGElement> {
  // Replace isActive with status
  status?: SDKStatus;
}

// Function to get color based on status
const getColor = (status?: SDKStatus): string => {
  switch (status) {
    case "Installed":
      return "#03AE65"; // Green
    case "Pending":
      return "#FFC107"; // Yellow
    case "Uninstalled":
      return "#BDBDBD"; // Gray
    default:
      return "#BDBDBD"; // Default to Gray if status is unknown or undefined
  }
};

export const StatusDotIcon: React.FC<StatusDotIconProps> = ({
  status,
  ...props
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.00049 12C6.88634 12 5.94105 11.612 5.16464 10.8358C4.38821 10.0598 4 9.11464 4 8.00049C4 6.88634 4.38805 5.94105 5.16415 5.16464C5.94024 4.38821 6.88536 4 7.99951 4C9.11367 4 10.0589 4.38805 10.8354 5.16415C11.6118 5.94024 12 6.88536 12 7.99952C12 9.11367 11.6119 10.0589 10.8358 10.8354C10.0598 11.6118 9.11464 12 8.00049 12Z"
      // Use the getColor function
      fill={getColor(status)}
    />
  </svg>
);
